import { Badge } from '@procureai/uix';
import type { CustomCellRendererProps } from 'ag-grid-react';

import { type SavingsListQuery, SavingStatus } from '@/generated/gql/graphql';

type SavingsListRow = SavingsListQuery['savings'][number];

type BadgeVariant = 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'info' | 'outline';

const statusVariants: Record<SavingStatus, BadgeVariant> = {
  [SavingStatus.DRAFT]: 'secondary',
  [SavingStatus.COMPLETED]: 'success',
};

export const StatusBadgeCellRenderer = ({ value }: CustomCellRendererProps<SavingsListRow, SavingStatus | null>) => {
  if (!value) return null;
  return <Badge variant={statusVariants[value] ?? 'default'}>{value}</Badge>;
};
